import {
  SET_SUBSCRIBEDMEMBERS_DATA,
  SET_SUBSCRIBEDMEMBERS_COUNT,
} from "../../actions/types/types";

const initState = {
  members: [],
  memberCount: 0,
};

const SubscribedUsersReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_SUBSCRIBEDMEMBERS_DATA:
      return {
        ...state,
        members: action.payload.data,
      };
    case SET_SUBSCRIBEDMEMBERS_COUNT:
      return {
        ...state,
        memberCount: action.payload.data,
      };
    default:
      return { ...state };
  }
};

export default SubscribedUsersReducer;
